export const environment = {
  production: false,
  serverUrl: 'https://dev2-lighthouse-api.dnvsspl.com/v1/',
  imageUrl: 'https://dev2-lighthouse-api.dnvsspl.com/v1/file/image/',
  pdfUrl: 'https://dev2-lighthouse-api.dnvsspl.com/v1/file/document/',
};

